import { db } from '../../db';
import { doc, setDoc } from 'firebase/firestore';
import { Listing } from '@/models/Listing';
import { buildListingActiveStatusUpdate } from '@strenforcement/domain/listing';
import { getCollectionPage } from './getCollectionPage';

export class FirestoreListingRepository {
  async listingsSearch(city, options = {}) {
    return getCollectionPage(
      `cities/${city.id}/listings`,
      docSnap => new Listing(city, docSnap),
      options
    );
  }

  async updateListingStatus(cityId, listingId, payload = {}) {
    const hasStatus = Object.prototype.hasOwnProperty.call(payload, 'status');
    if (!hasStatus || typeof payload.status !== 'string') {
      throw new Error('status is required');
    }
    const normalizedStatus = payload.status.trim().toLowerCase();
    if (normalizedStatus !== 'active' && normalizedStatus !== 'inactive') {
      throw new Error('status must be "active" or "inactive"');
    }

    const patch = buildListingActiveStatusUpdate({
      active: normalizedStatus === 'active',
      currentUser: null,
      now: new Date()
    });

    const firestore = await db;
    await setDoc(doc(firestore, 'cities', cityId, 'listings', listingId), patch, { merge: true });
    return {
      listing: {
        id: listingId,
        data: patch
      }
    };
  }
}
